import { EditorThemeOption } from "./hooks/useEditorThemes";

/**
 * The option a package's base preview (no theme) is rendered with: the coach's default theme. A
 * package without a coach renders its base preview with standard branding, so it has none.
 */
export function baseThemeOption(options: EditorThemeOption[], coachId: number | null): EditorThemeOption | undefined {
  return coachId != null ? options.find(option => option.kind === "default") : undefined;
}
